import { makeStyles } from "@material-ui/core/styles";

export const useBaseClientManagementStyles = makeStyles((theme) => ({
  root: {
    width: "50%",
  },
  header: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      marginTop: "10px",
    },
    display: "flex",
  },
  card: {
    width: "98%",
  },
  descBlock: {
    display: "flex",
  },
  descLabel: {
    margin: "0px",
    fontWeight: 700,
    marginBottom: "10px",
  },
  descValue: {
    margin: "0px",
    marginLeft: "5px",
    marginRight: "20px",
  },
  deleteButton: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: "50px",
      width: "98%",
    },
    marginTop: "20px",
    width: "200px",
  },
  error: {
    color: theme.palette.error.main,
  },
  sensitiveButton: {
    [theme.breakpoints.down("sm")]: {
      maxWidth: "none",
      width: "100%",
    },
    marginTop: "20px",
    width: "200px",
  },
  textField: {
    "& .Mui-error": {
      color: "rgba(255,0,0,.7)",
    },
    "& .MuiFormHelperText-root": {
      color: "rgba(255,0,0,.7)",
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: "rgba(255,0,0,.7) !important",
    },
  },
}));
